import {
  Flex,
  Table,
  Checkbox,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Box,
} from "@chakra-ui/react";
import React, { useMemo, useState, useEffect } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import { useListContext } from "../../../../../contexts/listContext";

export default function SuspectedBrandsTable(props) {
  const { finalData, heading } = props;
  const { list, checkedPlatforms, abuse_type, dateFilter } = useListContext();

  const userInfo = JSON.parse(localStorage.getItem('PAuser'));
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const headerBg = useColorModeValue("gray.50", "gray.700");
  const hoverBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const tableBg = useColorModeValue("white", "gray.800");
  const headerTextColor = useColorModeValue("gray.700", "gray.200");
  const rowTextColor = useColorModeValue("gray.800", "gray.100");
  const countTextColor = useColorModeValue("gray.700", "gray.200");
  const badgeBg = useColorModeValue("blue.50", "blue.900");
  const badgeColor = useColorModeValue("blue.700", "blue.200");

  const colours = [
    "#6ce5e8", "#41b8d5", "#2d8bba", "#2f5f98", "#31356e", "#111D4A",
    "#98D9E1", "#85C1E9", "#5DADE2", "#2E86C1", "#1B4F72", "#0E2F44"
  ]
    ;

  return (
    <Box
      borderRadius="12px"
      overflow="hidden"
      border="1px solid"
      borderColor={borderColor}
      bg={tableBg}
      boxShadow="md"
      width="100%"
      maxWidth="100%"
      alignSelf="center"
      display="inline-block"
      marginLeft={1}
    >

      <Table variant="simple" size="md">
        <Thead bg={headerBg}>
          <Tr>
            <Th
              width="60px"
              borderBottom="1px solid"
              borderColor={borderColor}
              py="16px"
              px="16px"
            />
            <Th
              borderBottom="1px solid"
              borderColor={borderColor}
              textAlign="left"
              py="16px"
              px="16px"
              fontSize="14px"
              fontWeight="600"
              color={headerTextColor}
              textTransform="none"
              letterSpacing="0.5px"
            >
              {heading}
            </Th>
            <Th
              borderBottom="1px solid"
              borderColor={borderColor}
              textAlign="center"
              py="16px"
              px="16px"
              fontSize="14px"
              fontWeight="600"
              color={headerTextColor}
              textTransform="none"
              letterSpacing="0.5px"
              width="120px"
            >
              Count
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {finalData?.map((row, index) => (
            <Tr
              key={index}
              _hover={{ bg: hoverBg }}
              transition="background-color 0.2s ease"
            >
              <Td
                borderBottom="1px solid"
                borderColor={borderColor}
                py="12px"
                px="16px"
              >
                <Box
                  width="20px"
                  height="20px"
                  borderRadius="50%"
                  bg={colours[index % colours.length]}
                  boxShadow="0 2px 4px rgba(0,0,0,0.1)"
                />
              </Td>
              <Td
                borderBottom="1px solid"
                borderColor={borderColor}
                py="12px"
                px="16px"
                fontSize="14px"
                color={rowTextColor}
                fontWeight="500"
              >
                {row.brand || row.sellers || row.platform_name}
              </Td>
              <Td
                borderBottom="1px solid"
                borderColor={borderColor}
                py="12px"
                px="16px"
                textAlign="center"
                fontSize="14px"
                color={countTextColor}
                fontWeight="600"
              >
                <Box
                  as="span"
                  bg={badgeBg}
                  color={badgeColor}
                  px="8px"
                  py="4px"
                  borderRadius="6px"
                  fontSize="13px"
                  fontWeight="600"
                >
                  {row.count}
                </Box>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
}